<template>
  <div class="col-md-4">
    <strong>Günstige Standardgrößen: </strong>
    <div v-if="alternativeVariants !== null && alternativeVariants.length > 0">
      <ul class="list-group">
        <li v-for="(item, index) in alternativeVariants" :key="index" class="list-group-item" @click="onSelectItem(item.width, item.height)">
          {{ item.width }}x{{ item.height }}cm<br>
          <span class="badge badge-warning">{{ Math.ceil(item.total) | currency }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  props: {
    // eslint-disable-next-line
    dimension: null
  },
  computed: {
    ...mapGetters({
      alternativeVariants: 'configurator/alternativeVariants',
      steps: 'configurator/steps',
      price: 'configurator/price'
    })
  },
  watch: {
    dimension: function () {
      const h = this.dimension.height.value
      const w = this.dimension.width.value
      this.setAlternative({ width: w, height: h })
    }
  },
  methods: {
    ...mapActions({
      setAlternative: 'configurator/setAlternative',
      setDimension: 'configurator/setDimension'
    }),
    onSelectItem (width, height) {
      this.dimension.width.value = Number.parseInt(width)
      this.dimension.height.value = Number.parseInt(height)
      this.setDimension({ type: 'width', value: this.dimension.width.value })
      this.setDimension({ type: 'height', value: this.dimension.height.value })
      this.setAlternative({ height: height, width: width })
    }
  }
}
</script>
